import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
}

export default function LoadingSpinner({ 
  size = 'md', 
  color = 'blue-600' 
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <div 
        className={`animate-spin rounded-full border-4 border-t-transparent ${sizeClasses[size]}`}
        style={{ borderColor: `currentColor transparent currentColor currentColor` }}
      >
        <span className="sr-only">Chargement...</span>
      </div>
      <p className={`text-${color} font-medium`}>Chargement...</p>
    </div>
  );
} 